import { ANALYTICS_VERSION, type AnalyticsEventMap, type AnalyticsEventName } from "./events";
import { capture } from "./posthogClient";

/**
 * The single typed entry point every event in this codebase goes
 * through - generic over `AnalyticsEventMap`, so passing the wrong
 * property shape for a given event name is a compile error. Stamps
 * `analytics_version` on every event itself, so no call site can forget
 * it or get it wrong.
 *
 * Deliberately the only function `gameAnalytics.ts` (and, transitively,
 * every scene) calls - `posthog-js` itself is never imported outside
 * `posthogClient.ts`.
 */
export function trackEvent<K extends AnalyticsEventName>(name: K, properties: Omit<AnalyticsEventMap[K], "analytics_version">): void {
  capture(name, { ...properties, analytics_version: ANALYTICS_VERSION });
}
